const US = require('./en-US.json');

export default {
  'en-US': US,
};
